import { useEffect, useContext } from 'react';
import Footer from './Footer';
import SideBar from './SideBar';
import TopHeader from './TopHeader';
import { CourseMenuContext } from 'context/CourseSubMenu';
import { withRouter } from 'react-router-dom';

function AdminLayout({ children, customProps = {}, location }) {
  const { changeMenu } = useContext(CourseMenuContext);
  const { sideMenu = {} } = customProps || {};

  useEffect(() => {
    changeMenu(sideMenu);
    return () => {};
  }, [location]);

  return (
    <div className="container-fluid app_wrap">
      <SideBar />
      <main>
        <TopHeader />
        {children}
        <Footer />
      </main>
    </div>
  );
}

export default withRouter(AdminLayout);
